import { render, staticRenderFns } from "./IconMetrics.vue?vue&type=template&id=3f528160&scoped=true"
import script from "./IconMetrics.vue?vue&type=script&lang=js"
export * from "./IconMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f528160",
  null
  
)

export default component.exports